import { render, staticRenderFns } from "./settle_record.vue?vue&type=template&id=198bff49&scoped=true"
import script from "./settle_record.vue?vue&type=script&lang=js"
export * from "./settle_record.vue?vue&type=script&lang=js"
import style0 from "./settle_record.vue?vue&type=style&index=0&id=198bff49&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198bff49",
  null
  
)

export default component.exports